import React from 'react';

const ArrowRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 18 18">
    <path fill="#FFF" d="M9.188 1.773L7.848 0.5 0 8 7.846 15.5 9.185 14.224 3.63 8.912 18 8.913 18 7.087 3.631 7.086z" transform="matrix(-1 0 0 1 18 1)"/>
  </svg>
);

export default ArrowRight;
